import React from 'react';

import { observer } from 'mobx-react';

import classes from './PriceInfo.module.scss';
import { PriceInfoSection } from '../../../../components/checkout/PriceInfoSection/PriceInfoSection';
import { getPriceView } from '../../../../../shared/utils/stringUtils';
import { checkoutStore } from '../../../../stores/checkoutStore';
import { CurrentPrice } from '../../../../components/checkout/CurrentPrice/CurrentPrice';
import { DiscountDescription } from '../../../../components/checkout/DiscountDescription/DiscountDescription';
import {
  BILLING_PERIOD_TYPE,
  BillingPeriodType,
} from '../../../../constants/billingPeriodType';

const PriceInfo = observer(() => {
  const { checkoutInfo, subscriptionTypeFlags, billingPeriodTypeFlags } = checkoutStore;

  if (!checkoutInfo) {
    return null;
  }

  const { subscription, promocode } = checkoutInfo;
  // for regular to check if next payment is with discount
  const isMonthlyDiscountUsed =
    Boolean(promocode) &&
    subscription.monthlyRenewalPriceFinal !== subscription.monthlyRenewalPrice;

  // promocode can exist but not used to current payment (saved for next payment)
  const isPromocodeUsedToCurrentPayment =
    Boolean(promocode) && checkoutInfo.checkoutDetails.discountAmount !== 0;

  const label = billingPeriodTypeFlags.DAILY ? 'Pay for' : 'Subscribe to';

  const scanIqSufixConfig: Record<BillingPeriodType, string> = {
    [BILLING_PERIOD_TYPE.MONTHLY]: '/ per month',
    [BILLING_PERIOD_TYPE.DAILY]: '/ per scan',
  };

  return (
    <PriceInfoSection label={label} name={subscription.name}>
      {subscriptionTypeFlags.REACTIVATION && (
        <CurrentPrice
          price={subscription.monthlyRenewalPriceFinal}
          hasDiscount={isPromocodeUsedToCurrentPayment}
          discountPercent={promocode?.discountPercent}
          oldPrice={subscription.monthlyRenewalPrice}
          suffix="/ per month"
        />
      )}
      {subscriptionTypeFlags.REGULAR && (
        <>
          <CurrentPrice
            price={subscription.initialPlanPriceFinal}
            hasDiscount={isPromocodeUsedToCurrentPayment}
            discountPercent={promocode?.discountPercent}
            oldPrice={subscription.initialPlanPrice}
            suffix={`/ initial payment for ${subscription.initialPlanDuration} months`}
          />
          <p className={classes.renewalNote}>
            Then {getPriceView(subscription.monthlyRenewalPriceFinal)}/month
            {isMonthlyDiscountUsed && (
              <span>
                ,&nbsp;
                <DiscountDescription
                  discountPercent={promocode?.discountPercent}
                  oldPrice={subscription.monthlyRenewalPrice}
                />
              </span>
            )}
          </p>
        </>
      )}
      {subscriptionTypeFlags.SCAN_IQ && (
        <CurrentPrice
          price={subscription.monthlyRenewalPriceFinal}
          hasDiscount={isPromocodeUsedToCurrentPayment}
          discountPercent={promocode?.discountPercent}
          oldPrice={subscription.monthlyRenewalPrice}
          suffix={scanIqSufixConfig[subscription.billingPeriodType]}
        />
      )}
    </PriceInfoSection>
  );
});

export { PriceInfo };
